import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsService } from './settings/settings.service';
import { TranslatorService } from './settings/translator.service';
import { MemberService } from './members/member.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../../environments/environment';
import { SessionService } from './session/session.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Angulartics2Module, Angulartics2Settings } from 'angulartics2';
import { CheckForUpdateService } from './ngsw/check-for-update.service';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { UpdateService } from './ngsw/update.service';
import { CLIENT_TRACKER_KEY } from './tracking/google-analytics';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { SignedInOrAutoLoginGuard } from './guards/signed-in-or-auto-login.guard';
import { OffersHttpService } from '@app/core/store/offers/offers-http.service';
import { ForcedProfileUpdateGuard } from '@app/core/guards/force-profile-update/forced-profile-update.guard';
import { GamesApiService } from '@app/games/services/games-api.service';
import { SpaycialIntegrationService } from '@app/core/spaycial-integration.service';
import { SpaycialIntegrationApiService } from '@app/+spaycial-integration/api/spaycial-integration-api.service';
import { ForceUpdateService } from '@app/core/guards/force-profile-update/force-update.service';
import { SimpleCookieConsentComponent } from '@app/core/cookie-consent/simple-cookie-consent/simple-cookie-consent.component';
import { ExtendedCookieConsentComponent } from '@app/core/cookie-consent/extended-cookie-consent/extended-cookie-consent.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LegalDocumentsService } from './legal-documents/legal-documents.service';
import { SessionApiService } from '@app/core/session/session-api.service';
import { MembersApiV2Service } from '@app/core/members/members-api-v2.service';
import { MembersApiV3Service } from '@app/core/members/members-api-v3.service';
import { SessionApiMigrationProviderService } from '@app/core/session/session-api-migration-provider.service';
import { SessionOidcApiService } from '@app/core/session/session-oidc-api.service';
import { MissingPropertiesService } from '@app/core/missing-properties.service';
import { TranslationsService } from './settings/translations.service';
import { provideTranslateService } from '@ngx-translate/core';

export const ANGULARTICS_SETTINGS: Partial<Angulartics2Settings> = {
  ga: { additionalAccountNames: [CLIENT_TRACKER_KEY], anonymizeIp: true },
  pageTracking: { clearQueryParams: true, clearHash: true },
};

@NgModule({
  exports: [
    CookieConsentComponent,
  ],
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    Angulartics2Module.forRoot(ANGULARTICS_SETTINGS),
    ModalModule.forRoot(),
    CookieConsentComponent,
    SimpleCookieConsentComponent,
    ExtendedCookieConsentComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: `${environment.webforms_api}/translations/`,
        suffix: '.json',
      }),
    }),
    SettingsService,
    MissingPropertiesService,
    TranslatorService,
    MembersApiV2Service,
    MembersApiV3Service,
    MemberService,
    SessionService,
    SessionApiService,
    SessionOidcApiService,
    LegalDocumentsService,
    CheckForUpdateService,
    BsLocaleService,
    UpdateService,
    SignedInOrAutoLoginGuard,
    ForcedProfileUpdateGuard,
    ForceUpdateService,
    OffersHttpService,
    GamesApiService,
    SpaycialIntegrationService,
    SpaycialIntegrationApiService,
    provideHttpClient(withInterceptorsFromDi()),
    SessionApiMigrationProviderService,
    TranslationsService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
